import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { partyToken: String }

  redirectToCheckout(event) {
    event.preventDefault()

    const productId = event.target.dataset.productId
    if (!productId) {
      console.error('Product ID not found')
      return
    }

    // Get party token from the URL or data attribute
    const partyToken = this.partyTokenValue || this.getPartyTokenFromUrl()
    if (!partyToken) {
      console.error('Party token not found')
      alert('Unable to process checkout. Please refresh the page and try again.')
      return
    }

    // Create form and submit to checkout endpoint
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `/open/party/${partyToken}/product/${productId}/checkout`

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    document.body.appendChild(form)
    form.submit()
  }

  getPartyTokenFromUrl() {
    // Extract party token from URL path like /open/party/TOKEN
    const pathMatch = window.location.pathname.match(/\/open\/party\/([^\/]+)/)
    return pathMatch ? pathMatch[1] : null
  }
}
